var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelfassgin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C6.02778 14 5.11713 13.8153 4.26806 13.4458C3.41898 13.0764 2.68009 12.5773 2.0514 11.9486C1.42269 11.3199 0.923611 10.581 0.554167 9.73194C0.184722 8.88287 0 7.97222 0 7C0 6.02778 0.184722 5.11713 0.554167 4.26806C0.923611 3.41898 1.42269 2.68009 2.0514 2.0514C2.68009 1.42269 3.41898 0.923611 4.26806 0.554167C5.11713 0.184722 6.02778 0 7 0V1.5C5.47222 1.5 4.17361 2.03318 3.10417 3.09954C2.03472 4.16592 1.5 5.46453 1.5 6.99538C1.5 8.52624 2.03363 9.82639 3.1009 10.8958C4.16816 11.9653 5.46786 12.5 7 12.5V14ZM10.5 10.5L9.4375 9.4375L11.125 7.75H5V6.25H11.125L9.4375 4.5625L10.5 3.5L14 7L10.5 10.5Z",
    fill: "#1B436E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfassgin);
export default __webpack_public_path__ + "static/media/selfassgin.a9508c2821481a85b79fd188ef53b47e.svg";
export { ForwardRef as ReactComponent };